import { useState } from "react";
import { formatNumber } from "../../utils";
import { IndividualQuoteRequestModal } from "./IndividualQuoteRequestModal";
import { QuoteCard } from "./QuoteCard";
import { QuoteCardButton } from "./QuoteCardButton";
import { QuoteCardTitle } from "./QuoteCardTitle";

export const IndividualQuoteCard: React.FC<{
  individualPlus: number | undefined;
  individualIntegral: number | undefined;
  pricePerPlus: number;
  pricePerIntegral: number;
  schoolYear: string;
  nces: string;
}> = ({
  individualPlus,
  individualIntegral,
  pricePerPlus,
  pricePerIntegral,
  schoolYear,
  nces,
}) => {
  const [showRequestModal, setShowRequestModal] = useState(false);

  const formattedSchoolYear = schoolYear
    .split("-")
    .map((year) => parseInt(year, 10) + 2000)
    .join("-");

  return (
    <>
      <QuoteCard tag="Current License">
        <div className="flex flex-col">
          <QuoteCardTitle
            tierText={
              individualPlus && individualIntegral
                ? "Plus / Integral"
                : individualPlus
                ? "Plus"
                : "Integral"
            }
            licenseText="Individual Licenses"
          />

          <p className="mb-10 text-lg text-dm-charcoal-500">
            {individualPlus && individualIntegral
              ? `You purchased ${formatNumber(
                  individualPlus
                )} PLUS and ${formatNumber(
                  individualIntegral
                )} INTEGRAL licenses for the ${formattedSchoolYear} school year.`
              : individualPlus
              ? `You purchased ${formatNumber(
                  individualPlus
                )} PLUS licenses for the ${formattedSchoolYear} school year.`
              : `You purchased ${formatNumber(
                  individualIntegral || 0
                )} INTEGRAL licenses for the ${formattedSchoolYear} school year.`}
          </p>

          <QuoteCardButton
            theme="highlighted"
            onClick={() => setShowRequestModal(true)}
          >
            Request Quote
          </QuoteCardButton>
        </div>

        <IndividualQuoteRequestModal
          individualPlus={individualPlus}
          individualIntegral={individualIntegral}
          pricePerPlus={pricePerPlus}
          pricePerIntegral={pricePerIntegral}
          nces={nces}
          visible={showRequestModal}
          onClose={() => setShowRequestModal(false)}
        />
      </QuoteCard>
    </>
  );
};
